import styled from "@emotion/styled";
import { physioMeMobileBreakpoint, physioMeTabletBreakpoint } from "@ui/style";
import React from "react";

interface ProspectPageProps {
	title: string;
	description: string;
	children: React.ReactNode;
}

export const ProspectFormContainer = ({ title, description, children }: ProspectPageProps): JSX.Element => (
	<FormContainer>
		<Title>{title}</Title>
		<div>{description}</div>
		<div>{children}</div>
	</FormContainer>
);

const Title = styled.div`
	font-family: "HeadingNow";
	font-style: normal;
	font-weight: 500;
	font-size: 4rem;
	line-height: 100%;
	overflow-wrap: break-word;

	span {
		font-family: "HeadingNow";
	}

	@media ${physioMeTabletBreakpoint} {
		font-size: 2.5rem;
	}

	@media ${physioMeMobileBreakpoint} {
		font-size: 2rem;
	}
`;

const FormContainer = styled.div`
	display: grid;
	place-self: start center;
	gap: 24px;
`;
